import { ComponentType } from 'react';
import { Typography } from '@mui/material';
import { OrganizationsEditForm, OrganizationsEditFormProps } from '../organizations-edit-form';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from '../../dialogs';

interface OrganizationsEditDialogProps extends OrganizationsEditFormProps {
  title?: string;
  popDialog?: any;
}

export const OrganizationsEditDialog: ComponentType<OrganizationsEditDialogProps> = ({
  title: dialogTitle,
  id,
  popDialog,
  onSubmit,
  ...props
}) => {
  const { t } = useTranslation();
  const defaultTitle = !!id
    ? t('organizations.edit', 'Редактиовать организацию')
    : t('organizations.add', 'Добавить организацию');
  const title = dialogTitle ? dialogTitle : defaultTitle;

  return (
    <BaseDialog {...{ ...props, popDialog }}>
      {title && (
        <Typography variant="h2" component="h6" mb={2}>
          {title}
        </Typography>
      )}
      <OrganizationsEditForm id={id} onSubmit={onSubmit} onCancel={popDialog} />
    </BaseDialog>
  );
};
